import { Failure, UnhandledFailure } from 'src/app/core/utils/failure';
import { Injectable } from '@angular/core';
import { ClaimMultiRepositoryBase } from '../../domain/repositories/claim-multi-base.repository';
import { ClaimMultiEntity } from '../../domain/entities/claim-multi.entity';
import { ClaimMultiRemoteDataSource } from '../data-source/claim-multi-remote.datasource';
import { ClaimsPaginationParams } from '../../domain/entities/claim-pagination-params.entity';
import { MultiPagination } from '../../domain/entities/multi-pagination.entity';
import { UpdateClaimConciliatorEntity } from '../../domain/entities/update-claim-conciliator.entity';
import { UpdateClaimStatusEntity } from '../../domain/entities/update-claim-satus.entity';
import { DeleteClaimEntity } from '../../domain/entities/delete-claim.entity';
import { GetFileEntity } from '../../domain/entities/get-file.entity';

@Injectable()
export class ClaimMultiRepository extends ClaimMultiRepositoryBase {
  constructor(private claimRemote: ClaimMultiRemoteDataSource) {
    super();
  }
  override async getClaim(id: string): Promise<ClaimMultiEntity | Failure> {
    try {
      return await this.claimRemote.getClaim(id);
    } catch (error: any) {
      return new UnhandledFailure(error.message, error.code);
    }
  }

  override async createClaim(
    claim: ClaimMultiEntity
  ): Promise<string | Failure> {
    try {
      return await this.claimRemote.createClaim(claim);
    } catch (error: any) {
      return new UnhandledFailure(error.message, error.code);
    }
  }

    override async updateClaim(
      claim: ClaimMultiEntity
    ): Promise<string | Failure> {
      try {
        return await this.claimRemote.updateClaim(claim);
      } catch (error: any) {
        return new UnhandledFailure(error.message, error.code);
      }
    }

  override async getMultiClaims(
    params: ClaimsPaginationParams
  ): Promise<MultiPagination | Failure> {
    try {
      return await this.claimRemote.getMultiClaims(params);
    } catch (error: any) {
      return new UnhandledFailure(error.message, error.code);
    }
  }

  override async getAllFinishedClaims(
    params: ClaimsPaginationParams
  ): Promise<MultiPagination | Failure> {
    try {
      return await this.claimRemote.getAllFinishedClaims(params);
    } catch (error: any) {
      return new UnhandledFailure(error.message, error.code);
    }
  }

  override async updateClaimConciliator(
    claim: UpdateClaimConciliatorEntity
  ): Promise<string | Failure> {
    try {
      return await this.claimRemote.updateClaimConciliator(claim);
    } catch (error: any) {
      return new UnhandledFailure(error.message, error.code);
    }
  }

  override async updateClaimStatus(
    claim: UpdateClaimStatusEntity
  ): Promise<string | Failure> {
    try {
      return await this.claimRemote.updateClaimStatus(claim);
    } catch (error: any) {
      return new UnhandledFailure(error.message, error.code);
    }
  }

  override async deleteClaim(
    deleteClaim: DeleteClaimEntity
  ): Promise<string | Failure> {
    try {
      return await this.claimRemote.deleteClaim(deleteClaim);
    } catch (error: any) {
      return new UnhandledFailure(error.message, error.code);
    }
  }

  override async getFile(params: GetFileEntity): Promise<string | Failure> {
    try {
      return await this.claimRemote.getFile(params);
    } catch (error: any) {
      return new UnhandledFailure(error.message, error.code);
    }
  }
}
